import { Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage";
import Subjects from "./pages/Subjects";
import Lectures from "./pages/Lectures";
import VideoPlayer from "./pages/VideoPlayer";
import PlyrPlayer from "./pages/PlyrPlayer";
import ChapterLectures from "./pages/ChapterLectures";
import Login from "./pages/Login";
import Verify from "./pages/Verify"; 
import Subjects10 from "./pages/Subjects10";
import Lectures10 from "./pages/Lectures10";
import ChapterLectures10 from "./pages/ChapterLectures10";
import Login10 from "./pages/Login10";
import Verify10 from "./pages/Verify10"; 
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verify/:token" element={<Verify />} />

        {/* ✅ Protected Routes */}
        <Route path="/subjects" element={<ProtectedRoute><Subjects /></ProtectedRoute>} />
        <Route path="/lectures/:subject" element={<ProtectedRoute><Lectures /></ProtectedRoute>} />
        <Route path="/chapter-lectures/:subject/:chapterIndex" element={<ProtectedRoute><ChapterLectures /></ProtectedRoute>} />
        <Route path="/video/:subject/:chapterIndex" element={<ProtectedRoute><VideoPlayer /></ProtectedRoute>} />
        <Route path="/video/live" element={<ProtectedRoute><VideoPlayer /></ProtectedRoute>} />  

        <Route path="/login10" element={<Login10 />} />
        <Route path="/verify-abhay/:token" element={<Verify10 />} />

        {/* ✅ Protected Routes */}
        <Route path="/subjects-abhay" element={<ProtectedRoute><Subjects10 /></ProtectedRoute>} />
        <Route path="/lectures/Abhay/:subject" element={<ProtectedRoute><Lectures10 /></ProtectedRoute>} />
        <Route path="/chapter-lectures-abhay/:subject/:chapterIndex" element={<ProtectedRoute><ChapterLectures10 /></ProtectedRoute>} />
<Route
  path="/plyr/:subject/:chapterIndex"
  element={
    <ProtectedRoute>
      <PlyrPlayer />
    </ProtectedRoute>
  }
/>
        
        </Routes>
    </>
  );
}

export default App;
